import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { CustomApiHandler } from "@theStellarBlueprint/Store/CustomHandlerCreator";
import {
    CuttingToolConfigParamter,
    CuttingToolConfigState,
} from "@theStellarBlueprint/Store/Data/CuttingToolConfig/CuttingToolConfigState";

type HandlerType = CustomApiHandler<CuttingToolConfigParamter, CuttingToolConfigState>;

export const PopulateCuttingToolConfigParam: HandlerType = props => {
    props.apiParameter = props.parameter;
    props.dispatch({
        type: "Custom/CuttingToolConfig/PopulateCuttingToolConfigParam",
    });
};

export const CleanCuttingToolConfig: HandlerType = props => {
    props.dispatch({
        type: "Custom/CuttingToolConfig/CleanCuttingToolConfig",
    });
};

export const chain = [PopulateCuttingToolConfigParam, CleanCuttingToolConfig];

export const removeCuttingToolConfigSelection = createHandlerChainRunner(chain, "UpdateCuttingToolConfig");
export default removeCuttingToolConfigSelection;
